import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Flex, Box, Text } from '@rebass/emotion';

import { rem } from '@app/styles/theme/layout';
import Link from '@app/components/Link';
import { Button } from '@app/shop/components/Button';

import messages from './Cart.messages';
import CartAlerts from './CartAlerts';
import { CONTINUE_SHOPPING_LINK } from './Cart.constants';

const CartEmpty: FC = () => (
  <>
    <Box mb={20}>
      <CartAlerts />
    </Box>

    <Flex alignItems="center">
      <Box mr={rem(20)} py={rem(10)} px={rem(25)}>
        <Text fontWeight="bold">
          <FormattedMessage {...messages.emptyCartMessage} />
        </Text>
      </Box>

      <Link
        to={CONTINUE_SHOPPING_LINK}
        data-testid="cart-continue-shopping-button"
      >
        <Button type="primary">
          <FormattedMessage {...messages.emptyCartCTA} />
        </Button>
      </Link>
    </Flex>
  </>
);

export default CartEmpty;
